import { useState, useRef } from 'react';
const useReferences = () => {
    const [references, changeReferences] = useState([]); //引用列表
    const referencesRef = useRef([]); //引用列表
    const setReferences = (data) => {
        changeReferences(data);
        referencesRef.current = data;
    };
    return {
        references,
        setReferences,
        referencesRef
    };
};
export default useReferences;
